var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32 2.966h19.452a1 1 0 0 1 .855 1.517L12.9 20.552a1 1 0 0 1-1.711 0L1.465 4.483a1 1 0 0 1 .855-1.517",
    className: "down_svg__cls1"
  })));
};
export default SvgDown;